define((require) => {
    "use strict";

    const Class   = require("shared/util/Class");
    const $       = require("jquery");

    const BASE_URL = "https://apis.google.com/js/client.js";

    /**
     * Wraps the <a href="https://developers.google.com/api-client-library/javascript/start/start-js">Google APIs Client Library for JavaScript</a>.
     *
     * @see https://developers.google.com/api-client-library/javascript/start/start-js
     *
     * @class GoogleAPIClient
     * @author Kim
     */
    const GoogleAPIClient = Class.extend({

        _deferred: null,

        _loadPerformed: false,

        /**
         * Constructor.
         */
        constructor() {
            this._deferred = new $.Deferred();
        },

        /**
         * Starts loading the Google client library.
         *
         * <pre>
         * GoogleAPIClient.load().then(function (GoogleAPI) {
         *     var request = GoogleAPI.client.youtube.videos.list({});
         *     request.execute();
         * });
         * </pre>
         *
         * @return {Promise} A promise that resolves with the Google Client API
         * instance.
         */
        load() {
            if (!this._loadPerformed) {
                this._startFetching();
            }
            // Guard for future loads
            this._loadPerformed = true;
            // Return a promise
            return this._deferred.promise();
        },

        /**
         * @private
         *
         * Starts fetching the Google client library, and resolves the deferred
         * object if the load was successful.
         */
        _startFetching() {
            // Create callback in the global scope
            window.__gapiOnloadHandler = () => {
                // Cleanup and resolve
                delete window.__gapiOnloadHandler;
                this._deferred.resolve(window.gapi);
            };

            // Load the client library - specifying the onload callback
            $.getScript(`${BASE_URL}?onload=__gapiOnloadHandler`)
                .fail(this._deferred.reject);
        }

    });

    return new GoogleAPIClient();
});



// WEBPACK FOOTER //
// ./src/editor/services/GoogleAPIClient.js